import React from 'react'
import { Row, Col, LocaleProvider } from 'antd'
import Header from './components/Header'
import Footer from '_src/app/components/Footer'
import NavLeft from './components/NavLeft'
import BreadcrumbDom from './components/BreadcrumbDom'
import { withRouter } from 'react-router-dom'
import zh_CN from 'antd/lib/locale-provider/zh_CN'
import '../style/common.less'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

// import Home from './pages/home'
@withRouter 
class Admin extends React.Component {
  componentWillMount () {
    window._ROUTER_ = this.props
  }
  render () {
    return (
      <Row className="container">
        <Col span={4} className="nav-left">
          <NavLeft />
          {/* <Sider /> */}
        </Col>
        <Col span={20} className="main" id='main'>
          <Header />
          <Row className="content">
            <BreadcrumbDom />
            <LocaleProvider locale={zh_CN}>
              {this.props.children}
            </LocaleProvider>
          </Row>
          <Footer />
        </Col>
      </Row>
    )
  }
}
export default Admin